export default {
  Intl: window.Intl
};